import { useDispatch } from "react-redux";
import useErrorHandler from "../components/ErrorHandler";
import {fetchEmployees, setLoading as setEmployeeAPILoading} from "../features/employeesSlice";
import useMerchantPortalAxios from "../utils/axios";

export const useEmployeesAPIs = () => {

  const MerchantPortalClient = useMerchantPortalAxios();

  const dispatch = useDispatch();

  async function DeleteEmployee(payload) {
      dispatch(setEmployeeAPILoading("pending"));
      const res = await MerchantPortalClient.post(`/v1/PortalEmployee/DeleteEmployee`, payload);
      dispatch(setEmployeeAPILoading("idle"));
      dispatch(fetchEmployees());
      return res.data.Payload;

  }

  async function EditEmployee(
    payload
  ) {

      dispatch(setEmployeeAPILoading("pending"));
      const res = await MerchantPortalClient.post(`/v1/PortalEmployee/EditBranchEmployee`, payload);
      dispatch(setEmployeeAPILoading("idle"));
      dispatch(fetchEmployees());
      return res.data.Payload;
  }

  const AddEmployee = async (
    payload
  ) => {
      dispatch(setEmployeeAPILoading("pending"));
      const res = await MerchantPortalClient.post(`/v1/PortalEmployee/AddEmployee`, payload);
      dispatch(setEmployeeAPILoading("idle"));
      dispatch(fetchEmployees());
      return res.data.Payload;
  };

  return {
    DeleteEmployee,
    EditEmployee,
    AddEmployee,
  };
};
